module.exports = __webpack_public_path__ + "img/sedan.88ef7aa2.svg";